import {
  Button,
  Container,
  Flex,
  Image,
  PasswordInput,
  Stack,
  Text,
  TextInput,
  Title,
  Anchor,
  Alert,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import axios from "axios";
import { useLayoutEffect, useState } from "react";
import { URL } from "../../services/url";
import checkUserId from "../../utils/checkuserid";
import { IconAlertCircle, IconCar, IconLock, IconMail } from "@tabler/icons-react";

interface SignInResponse {
  success: boolean;
  response: string;
  user?: number;
}

const SignIn = () => {
  const isMobile = useMediaQuery("(max-width: 600px)");

  const [email, setEmail] = useState("");

  const [password, setPassword] = useState("");
  const [passwordErr, setPasswordErr] = useState(false);

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const isFormValid = email && password && !passwordErr && !loading && !error;

  useLayoutEffect(() => {
    checkUserId();

    // window.localStorage.setItem("userId", "4");
  }, []);

  const handleSignUp = async (e: any) => {
    e.preventDefault();
    if (isFormValid)
      try {
        setError("");
        setLoading(true);
        const response = await axios.post<SignInResponse>(`${URL}signin/`, {
          email,
          password,
        });

        console.log("🚀 ~ handleSignUp ~ response:", response);

        if (response.data.success) {
          const userId = response.data.user;
          // Store the user ID or any other relevant data in local storage or state management solution
          localStorage.setItem("userId", userId?.toString() || "");

          // const res = await axios.get(`${URL}check/${userId}/`);
          window.location.href = "/home";
          // else window.location.href = "/personal";
        } else {
          setError(response.data.response);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Sign up failed", error);
        setError("An error occurred during sign up");
      }
  };

  const passwordPattern =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?])[\w!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,}$/;

  const onBluePassword = (e: any) => {
    if (!passwordPattern.test(password)) {
      setError(
        "Password must contain at least 8 characters, one uppercase letter, one lowercase letter, one number and one special character"
      );
      setPasswordErr(true);
    } else {
      setError("");
      setPasswordErr(false);
    }
  };

  return (
    <Container
      size={isMobile ? "xs" : "sm"}
      px={isMobile ? "md" : "xl"}
      py={isMobile ? "xl" : "80px"}
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Stack gap="xl" align="stretch" w="100%" maw={400}>
        {/* Header */}
        <Stack gap="md">
          <Image 
            src="/landingimg.png" 
            maw={isMobile ? 100 : 120} 
          />
          <Stack gap={4}>
            <Title order={1} size={isMobile ? "h2" : "h1"} fw={700}>
              Sign in to Kabbie
            </Title>
            <Text size="sm" c="dimmed">
              Enter your credentials to access your account
            </Text>
          </Stack>
        </Stack>

        {/* Form */}
        <Stack gap="lg" w="100%">
              <TextInput
                label="Email Address"
                placeholder="driver@example.com"
                type="email"
                size="md"
                required
                leftSection={<IconMail size={18} />}
                value={email}
                onChange={(e) => setEmail(e.target.value.toLowerCase())}
                onFocusCapture={(e) => setError("")}
                styles={{
                  label: { marginBottom: "0.5rem" },
                }}
              />

              <PasswordInput
                label="Password"
                placeholder="Enter your password"
                required
                size="md"
                leftSection={<IconLock size={18} />}
                value={password}
                error={passwordErr}
                onChange={(e) => setPassword(e.target.value)}
                onFocusCapture={(e) => setError("")}
                onBlurCapture={onBluePassword}
                styles={{
                  label: { marginBottom: "0.5rem" },
                }}
              />

              {error && (
                <Alert
                  icon={<IconAlertCircle size={16} />}
                  color="red"
                  variant="light"
                  radius="md"
                >
                  <Text size="sm">{error}</Text>
                </Alert>
              )}

              <Flex justify="flex-end" mt="xs">
                <Anchor href="/forgot-password" size="sm" c="dimmed">
                  Forgot Password?
                </Anchor>
              </Flex>

          <Button
            fullWidth
            size="lg"
            mt="md"
            variant="gradient"
            gradient={{ from: '#000000', to: '#333333', deg: 145 }}
            onClick={handleSignUp}
            radius="md"
            loading={loading}
            loaderProps={{ type: "oval" }}
            disabled={!isFormValid}
          >
            Sign In
          </Button>

          <Stack gap="sm" mt="md">
            <Text size="sm" c="dimmed">
              New to Kabbie?{" "}
              <Anchor href="/signup" fw={600}>
                Create an account
              </Anchor>
            </Text>
            <Anchor href="/" size="sm" c="dimmed">
              ← Back to Home
            </Anchor>
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
};

export default SignIn;
